import React, { useState } from "react";
import theme from "../../Styles/theme";
import { ModalDivX } from "../ModalDivX";
import Modal from "react-modal";
import { Container, Span, Button, HandleSpan, Title } from "./styles";
import {
  IFuncionarioCartorio,
  IFuncionarioCartorioList,
  useFuncionarioCartorio,
} from "../../Hooks/funcionarioCartorio";
import { ModalLoader } from "../ModalLoader";
import { Alert } from "../Error/Alert";
import {
  IFuncionarioPrefeituraList,
  useFuncionarioPrefeitura,
} from "../../Hooks/funcionarioPrefeitura";
const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: theme.colors.secondary,
    minWidth: "40%",
    maxWidth: "80%",
    borderRadius: "0.25rem",
  },
};

interface Props {
  open: boolean;
  onClose(): void;
  data: IFuncionarioCartorioList[] | IFuncionarioPrefeituraList[];
  senha: string;
}
export function ListFuncionariosModal({ open, onClose, data, senha }: Props) {
  const { signIn } = useFuncionarioCartorio();
  const { SignInFuncionarioPrefeitura } = useFuncionarioPrefeitura();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({
    title: "",
    message: "",
  });
  function renderFuncionarios() {
    console.log(data);
    if (data) {
      if (data.length > 0) {
        return data.map((item) => {
          return (
            <Button
              onClick={async () => {
                try {
                  setLoading(true);
                  if (item.CARTORIO_ID) {
                    const teste = await signIn(item.ID, senha);
                  } else if (item.PREFEITURA_ID) {
                    const teste = await SignInFuncionarioPrefeitura(
                      item.ID,
                      senha
                    );
                  }
                } catch (error) {
                  console.log(error);
                  setError({
                    title: "Erro ao efetuar o login!",
                    message: "Não foi possível efetuar o login nesta conta!",
                  });
                } finally {
                  setLoading(false);
                }
              }}
            >
              {item.NOME}
              <HandleSpan>
                <Span>{item.ENTIDADE}</Span>
              </HandleSpan>
            </Button>
          );
        });
      }
    }
  }
  return (
    <Modal isOpen={open} onRequestClose={onClose} style={customStyles}>
      <ModalDivX execute={onClose} />
      <Title>Selecione a conta que deseja entrar:</Title>
      <Container>{renderFuncionarios()}</Container>

      <ModalLoader loading={loading} />
      <Alert
        title={error.title}
        message={error.message}
        open={error.message.length > 0}
        onClose={() => setError({ message: "", title: "" })}
      />
    </Modal>
  );
}
